var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "return-goods" },
    [
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "100px" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _vm.activeSubTab === 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "结算单号" } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入结算单号" },
                                    model: {
                                      value: _vm.form.settleNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "settleNo", $$v)
                                      },
                                      expression: "form.settleNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _vm.redBlueOffset
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "是否拆分扣款" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        size: "small",
                                        clearable: "",
                                        placeholder: "请选择"
                                      },
                                      model: {
                                        value: _vm.form.hasDeducted,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "hasDeducted", $$v)
                                        },
                                        expression: "form.hasDeducted"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "是", value: 1 }
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "否", value: 0 }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "售后单号" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入售后单号" },
                                model: {
                                  value: _vm.form.afterSaleOrderNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "afterSaleOrderNo", $$v)
                                  },
                                  expression: "form.afterSaleOrderNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "售后确认日期" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  clearable: false,
                                  "unlink-panels": "",
                                  type: "daterange",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  "range-separator": "-",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  size: "small"
                                },
                                on: { change: _vm.handleRangePickerChange },
                                model: {
                                  value: _vm.form.date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn default-btn",
                              staticStyle: { "margin-left": "100px" },
                              on: { click: _vm.exportData }
                            },
                            [_vm._v("导出")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn default-btn",
                              on: { click: _vm.resetData }
                            },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("tabs", {
            attrs: {
              tabList: _vm.subTabList,
              activeTab: _vm.activeSubTab,
              changeTab: _vm.changeTab
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeSubTab === 1,
                  expression: "activeSubTab === 1"
                }
              ]
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.refundTableData, "max-height": 300 },
                  on: { "expand-change": _vm.expandChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "expand", width: "55" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(props) {
                          return [
                            _c(
                              "el-table",
                              { attrs: { data: props.row.child } },
                              [
                                _c("el-table-column", {
                                  attrs: { label: "序号", prop: "serialNum" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "结算单号", prop: "settleNo" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "扣款数量",
                                    prop: "deductedCount"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: { label: "单价", prop: "price" }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "扣款总额",
                                    prop: "totalAmount"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "售后扣款时间",
                                    prop: "deductedTime"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "120", prop: "serialNum" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleConfirmDate",
                      label: "售后确认日期",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleOrderNo",
                      label: "售后单号",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuCode", label: "商品编码", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuName", label: "商品名称", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleConfirmQuantity",
                      label: "售后确认数量",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "price", label: "采购单价", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalAmount",
                      label: "售后总金额",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unSettledQuantity",
                      label: "结余",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "refundStatus", label: "状态", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isSplit",
                      label: "是否拆分扣款",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.isSplit === 1 ? "是" : "否")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeSubTab === 2,
                  expression: "activeSubTab === 2"
                }
              ]
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.unRefundTableData, "max-height": 300 }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "120", prop: "serialNum" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleConfirmDate",
                      label: "售后确认日期",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleOrderNo",
                      label: "售后单号",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.isSplit === 1
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#236BDC",
                                      cursor: "pointer"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.goOriginalOrder(
                                          scope.row.afterSaleOrderNo
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(scope.row.afterSaleOrderNo))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.isSplit === 0
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.afterSaleOrderNo))
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuCode", label: "商品编码", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "skuName", label: "商品名称", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "afterSaleConfirmQuantity",
                      label: "售后确认数量",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "price", label: "采购单价", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalAmount",
                      label: "售后总金额",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "unSettledQuantity",
                      label: "结余",
                      width: "120"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "refundStatus", label: "状态", width: "120" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isSplit",
                      label: "是否拆分扣款",
                      width: "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.isSplit === 1 ? "是" : "否")
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page,
              "page-sizes": [10, 50, 100, 200],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "settle-modal",
          attrs: {
            visible: _vm.orderDialogVisible,
            width: "80%",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.orderDialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title"
            },
            [_c("span", { staticClass: "title" }, [_vm._v("查看原单")])]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleClose("originOrderModal")
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { data: _vm.originalOrderList, border: "", height: "100" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "原单", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "confirmDate", label: "售后确认日期" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "saleOrder", label: "售后单号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "商品编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuName", label: "商品名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "originalQuantity", label: "原数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "unDeductQuantity", label: "待抵扣数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchasePrice", label: "采购单价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "originalTotalAmount", label: "原总价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "unDeductTotalAmount", label: "待抵扣总价" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: { data: _vm.deductionOrderList, border: "", height: "100" }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "抵扣单", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "confirmTime", label: "结算单确认日期" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "settleNo", label: "结算单" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "amount2" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "amount2" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "quantity", label: "扣款数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchasePrice", label: "采购单价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "purchaseTotalAmount", label: "扣款总价" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "抵扣状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterStatus")(scope.row.status))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "settleDate", label: "实际抵扣日期" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-411ddedc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-411ddedc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/r4SettlementReport/summaryReport/components/returnGoodsList.vue
// module id = null
// module chunks = 